import type { IconData } from '@stacksjs/iconify-core'

export const gitlabAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m12 21.42l3.684-11.333H8.32z\"/><path fill=\"currentColor\" d=\"m3.16 10.087l-1.123 3.444a.76.76 0 0 0 .277.852l9.685 7.038z\" opacity=\".25\"/><path fill=\"currentColor\" d=\"M3.16 10.087h5.16L6.1 3.262a.383.383 0 0 0-.728 0z\"/><path fill=\"currentColor\" d=\"m20.845 10.087l1.118 3.444a.76.76 0 0 1-.276.852l-9.688 7.038z\" opacity=\".25\"/><path fill=\"currentColor\" d=\"M20.845 10.087h-5.161L17.9 3.262a.383.383 0 0 1 .727 0l2.217 6.825Z\"/><path fill=\"currentColor\" d=\"m11.999 21.421l3.685-11.334h5.161zm0 0l-8.84-11.334H8.32z\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default gitlabAlt
